import TextDropdown from "components/inputs/text-dropdown";
import TextInput from "components/inputs/text-input";
import ModalTemplate from "components/modal/modal-template";
import Radio from "components/radio";
import Typography from "components/typography";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { ITrackArtists } from "types/musicData";
import { GetUserArtists } from "services/user/getUser";

interface IProps {
  close: () => void;
  confirm: (artist: ITrackArtists) => void;
}
const AddArtistModal = ({ close, confirm }: IProps) => {
  const [artistType, setArtistType] = useState("Primary Artist");
  const [artistName, setArtistName] = useState("");
  const [streamingService, setStreamingService] = useState(false);
  const [artistNames, setArtistNames] = useState<string[]>([]);

  const reset = () => {
    setArtistType("Primary Artist");
    setArtistName("");
    setStreamingService(false);
  };

  const userArtists = GetUserArtists();

  useEffect(() => {
    const artists = userArtists.map((artist) => artist.name);
    setArtistNames(artists);
  }, [userArtists]);

  return (
    <ModalTemplate
      header="Add Artist"
      confirmText="Add Artist"
      close={close}
      confirm={() => {
        confirm({ type: artistType, name: artistName });
        close();
        reset();
      }}
    >
      <TextDropdown
        placeholder="Enter artist name or select from plan artists"
        label="Artist Name"
        required
        value={artistName}
        onChange={(e) => setArtistName(e.target.value)}
        selectItem={(value) => setArtistName(value)}
        items={artistNames}
      />

      <ArtistTypeItem>
        <Radio
          value={artistType === "Primary Artist"}
          onClick={() => setArtistType("Primary Artist")}
        />
        <Typography color={Colors.white200} ml="0.4">
          Primary Artist
        </Typography>
      </ArtistTypeItem>
      <ArtistTypeItem>
        <Radio
          value={artistType === "Featured Artist"}
          onClick={() => setArtistType("Featured Artist")}
        />
        <Typography color={Colors.white200} ml="0.4">
          Featured Artist
        </Typography>
      </ArtistTypeItem>
      <ArtistTypeItem>
        <Radio
          value={artistType === "Remixer"}
          onClick={() => setArtistType("Remixer")}
        />
        <Typography color={Colors.white200} ml="0.4">
          Remixer
        </Typography>
      </ArtistTypeItem>
      <Typography mt="2.4" weight="medium" mb="1.6">
        Does this artist have music live on streaming services
      </Typography>
      <StreamingServiceRadioContainer>
        <Radio
          value={streamingService}
          onClick={() => setStreamingService(true)}
        />
        <Typography color={Colors.white200} ml="0.4" mr="5">
          Yes
        </Typography>
        <Radio
          value={!streamingService}
          onClick={() => setStreamingService(false)}
        />
        <Typography color={Colors.white200} ml="0.4">
          No
        </Typography>
      </StreamingServiceRadioContainer>
      {streamingService && (
        <>
          <StreamingServiceItem>
            <TextInput
              label="Spotify Artist URL"
              placeholder="Enter Spotify Artist Link"
            />
          </StreamingServiceItem>
          <StreamingServiceItem>
            <TextInput
              label="Apple Artist URL"
              placeholder="Enter Apple Music Artist Link"
            />
          </StreamingServiceItem>
          <StreamingServiceItem>
            <TextInput
              label="YouTube Music Artist URL"
              placeholder="Enter YouTube Music Artist Link"
            />
          </StreamingServiceItem>
        </>
      )}
    </ModalTemplate>
  );
};

export default AddArtistModal;

const ArtistTypeItem = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2.4rem;
`;

const StreamingServiceRadioContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StreamingServiceItem = styled.div`
  margin-top: 1.6rem;
`;
